import { useEffect, useMemo } from "react"

import { isAs400SyncInProgress } from "../utils/invoiceAs400Sync"

import type { Invoice } from "@/graphql/codegen/graphql"

export const AS400_SYNC_REFRESH_INTERVAL_MS = 5000

// AK-7157: a row whose AS400 sync is running keeps its "in progress" icon until the list is loaded again, so the
// loaded rows are refreshed while any of them waits on AS400 (AK-5649 AC2/AC4: no user action required). It stops
// once none is left and does not run in a background tab.
export const useAs400SyncAutoRefresh = (invoices: Invoice[], refresh: () => void): void => {
  const hasSyncInProgress = useMemo(() => invoices.some(isAs400SyncInProgress), [invoices])

  useEffect(() => {
    if (!hasSyncInProgress) return

    const intervalId = setInterval(() => {
      if (!document.hidden) refresh()
    }, AS400_SYNC_REFRESH_INTERVAL_MS)

    return () => clearInterval(intervalId)
  }, [hasSyncInProgress, refresh])
}
